import type { SvgIconComponent } from '@mui/icons-material';
import AddOutlined from '@mui/icons-material/AddOutlined';
import AlternateEmailOutlined from '@mui/icons-material/AlternateEmailOutlined';
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined';
import ArrowRightAltOutlined from '@mui/icons-material/ArrowRightAltOutlined';
import AssignmentTurnedInOutlined from '@mui/icons-material/AssignmentTurnedInOutlined';
import AttachFileOutlined from '@mui/icons-material/AttachFileOutlined';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import BusinessTwoTone from '@mui/icons-material/BusinessTwoTone';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import CalendarMonthTwoTone from '@mui/icons-material/CalendarMonthTwoTone';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import CallMergeOutlined from '@mui/icons-material/CallMergeOutlined';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import ChevronLeftOutlined from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import DescriptionTwoTone from '@mui/icons-material/DescriptionTwoTone';
import DragIndicatorOutlined from '@mui/icons-material/DragIndicatorOutlined';
import DriveFileMoveOutlined from '@mui/icons-material/DriveFileMoveOutlined';
import EditDocument from '@mui/icons-material/EditDocument';
import EditOutlined from '@mui/icons-material/EditOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import EventAvailableOutlined from '@mui/icons-material/EventAvailableOutlined';
import ExpandLessOutlined from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlined from '@mui/icons-material/ExpandMoreOutlined';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import FilterListOutlined from '@mui/icons-material/FilterListOutlined';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import FolderTwoTone from '@mui/icons-material/FolderTwoTone';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import GroupsTwoTone from '@mui/icons-material/GroupsTwoTone';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import HomeTwoTone from '@mui/icons-material/HomeTwoTone';
import InboxOutlined from '@mui/icons-material/InboxOutlined';
import InboxTwoTone from '@mui/icons-material/InboxTwoTone';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import LabelOutlined from '@mui/icons-material/LabelOutlined';
import LinkOffOutlined from '@mui/icons-material/LinkOffOutlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import LockTwoTone from '@mui/icons-material/LockTwoTone';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import MenuOutlined from '@mui/icons-material/MenuOutlined';
import MoreHorizOutlined from '@mui/icons-material/MoreHorizOutlined';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import OpenInNewOutlined from '@mui/icons-material/OpenInNewOutlined';
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import PlaceOutlined from '@mui/icons-material/PlaceOutlined';
import PrintOutlined from '@mui/icons-material/PrintOutlined';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import RefreshOutlined from '@mui/icons-material/RefreshOutlined';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import SendOutlined from '@mui/icons-material/SendOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SettingsTwoTone from '@mui/icons-material/SettingsTwoTone';
import ShareOutlined from '@mui/icons-material/ShareOutlined';
import SortOutlined from '@mui/icons-material/SortOutlined';
import SwapHorizOutlined from '@mui/icons-material/SwapHorizOutlined';
import UndoOutlined from '@mui/icons-material/UndoOutlined';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import type { SvgIconProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<SvgIconProps, 'children'>>;

function defineIcon(Icon: SvgIconComponent, displayName: string) {
  function DesignSystemIcon(props: Props) {
    return <Icon {...props} />;
  }
  DesignSystemIcon.displayName = displayName;

  return DesignSystemIcon;
}

export const AccountIcon = defineIcon(PersonOutlineOutlined, 'AccountIcon');
export const AddIcon = defineIcon(AddOutlined, 'AddIcon');
export const AddToCalendarIcon = defineIcon(EventAvailableOutlined, 'AddToCalendarIcon');
export const AiIcon = defineIcon(AutoAwesomeOutlined, 'AiIcon');
export const ArchiveIcon = defineIcon(ArchiveOutlined, 'ArchiveIcon');
export const AssignmentTurnedInIcon = defineIcon(AssignmentTurnedInOutlined, 'AssignmentTurnedInIcon');
export const AttachmentIcon = defineIcon(AttachFileOutlined, 'AttachmentIcon');
export const BackIcon = defineIcon(ArrowBackOutlined, 'BackIcon');
export const BusinessIcon = defineIcon(BusinessOutlined, 'BusinessIcon');
export const CalendarIcon = defineIcon(CalendarTodayOutlined, 'CalendarIcon');
export const CheckCircleIcon = defineIcon(CheckCircle, 'CheckCircleIcon');
export const CloseIcon = defineIcon(CloseOutlined, 'CloseIcon');
export const CollapseIcon = defineIcon(ExpandLessOutlined, 'CollapseIcon');
export const CommunicationIcon = defineIcon(EmailOutlined, 'CommunicationIcon');
export const CopyIcon = defineIcon(ContentCopyOutlined, 'CopyIcon');
export const DeleteIcon = defineIcon(DeleteOutlined, 'DeleteIcon');
export const DocumentIcon = defineIcon(DescriptionOutlined, 'DocumentIcon');
export const DownloadIcon = defineIcon(FileDownloadOutlined, 'DownloadIcon');
export const EmailAddressIcon = defineIcon(AlternateEmailOutlined, 'EmailAddressIcon');
export const DragHandleIcon = defineIcon(DragIndicatorOutlined, 'DragHandleIcon');
export const EditDocumentIcon = defineIcon(EditDocument, 'EditDocumentIcon');
export const EditIcon = defineIcon(EditOutlined, 'EditIcon');
export const ErrorIcon = defineIcon(ErrorOutlineOutlined, 'ErrorIcon');
export const ExpandIcon = defineIcon(ExpandMoreOutlined, 'ExpandIcon');
export const FilterIcon = defineIcon(FilterListOutlined, 'FilterIcon');
export const ForwardIcon = defineIcon(ArrowRightAltOutlined, 'ForwardIcon');
export const HelpIcon = defineIcon(HelpOutlineOutlined, 'HelpIcon');
export const HideIcon = defineIcon(VisibilityOffOutlined, 'HideIcon');
export const InfoIcon = defineIcon(InfoOutlined, 'InfoIcon');
export const ConnectIcon = defineIcon(LinkOutlined, 'ConnectIcon');
export const DisconnectIcon = defineIcon(LinkOffOutlined, 'DisconnectIcon');
export const LogoutIcon = defineIcon(LogoutOutlined, 'LogoutIcon');
export const LabelIcon = defineIcon(LabelOutlined, 'LabelIcon');
export const TagIcon = defineIcon(LabelOutlined, 'TagIcon');
export const LocationIcon = defineIcon(PlaceOutlined, 'LocationIcon');
export const MergeIcon = defineIcon(CallMergeOutlined, 'MergeIcon');
export const MoreActionsIcon = defineIcon(MoreVertOutlined, 'MoreActionsIcon');
export const MoveIcon = defineIcon(DriveFileMoveOutlined, 'MoveIcon');
export const NextIcon = defineIcon(ChevronRightOutlined, 'NextIcon');
export const OpenInNewIcon = defineIcon(OpenInNewOutlined, 'OpenInNewIcon');
export const OtherResourceIcon = defineIcon(MoreHorizOutlined, 'OtherResourceIcon');
export const PendingActionsIcon = defineIcon(PendingActionsOutlined, 'PendingActionsIcon');
export const TaskResourceIcon = AssignmentTurnedInIcon;
export const PendingItemResourceIcon = PendingActionsIcon;
export const PhoneIcon = defineIcon(PhoneOutlined, 'PhoneIcon');
export const PreviousIcon = defineIcon(ChevronLeftOutlined, 'PreviousIcon');
export const PrintIcon = defineIcon(PrintOutlined, 'PrintIcon');
export const ProviderIcon = defineIcon(BusinessOutlined, 'ProviderIcon');
export const RadioButtonUncheckedIcon = defineIcon(RadioButtonUnchecked, 'RadioButtonUncheckedIcon');
export const RefreshIcon = defineIcon(RefreshOutlined, 'RefreshIcon');
export const ReminderIcon = defineIcon(NotificationsOutlined, 'ReminderIcon');
export const RestoreIcon = defineIcon(UndoOutlined, 'RestoreIcon');
export const SaveIcon = defineIcon(SaveOutlined, 'SaveIcon');
export const SearchIcon = defineIcon(SearchOutlined, 'SearchIcon');
export const SendIcon = defineIcon(SendOutlined, 'SendIcon');
export const SettingsIcon = defineIcon(SettingsOutlined, 'SettingsIcon');
export const ShareIcon = defineIcon(ShareOutlined, 'ShareIcon');
export const SortIcon = defineIcon(SortOutlined, 'SortIcon');
export const TagStateIcon = defineIcon(CircleIcon, 'TagStateIcon');
export const TopicIcon = defineIcon(FolderOutlined, 'TopicIcon');
export const UploadIcon = defineIcon(FileUploadOutlined, 'UploadIcon');
export const CheckIcon = defineIcon(CheckOutlined, 'CheckIcon');
export const ValidateIcon = defineIcon(CheckOutlined, 'ValidateIcon');
export const ViewIcon = defineIcon(VisibilityOutlined, 'ViewIcon');
export const WarningIcon = defineIcon(WarningAmberOutlined, 'WarningIcon');

// App shell navigation and header.
export const CouncilIcon = defineIcon(GroupsOutlined, 'CouncilIcon');
export const HomeIcon = defineIcon(HomeOutlined, 'HomeIcon');
export const InboxIcon = defineIcon(InboxOutlined, 'InboxIcon');
export const MenuIcon = defineIcon(MenuOutlined, 'MenuIcon');
export const NotificationsIcon = defineIcon(NotificationsNoneOutlined, 'NotificationsIcon');
export const PlanningIcon = defineIcon(CalendarMonthOutlined, 'PlanningIcon');
export const PrivateIcon = defineIcon(LockOutlined, 'PrivateIcon');
export const SwitchSpaceIcon = defineIcon(SwapHorizOutlined, 'SwitchSpaceIcon');

// Experiment: two-tone variants for the app navigation only, to compare with the outlined doctrine.
export const CouncilTwoToneIcon = defineIcon(GroupsTwoTone, 'CouncilTwoToneIcon');
export const DocumentTwoToneIcon = defineIcon(DescriptionTwoTone, 'DocumentTwoToneIcon');
export const HomeTwoToneIcon = defineIcon(HomeTwoTone, 'HomeTwoToneIcon');
export const InboxTwoToneIcon = defineIcon(InboxTwoTone, 'InboxTwoToneIcon');
export const PlanningTwoToneIcon = defineIcon(CalendarMonthTwoTone, 'PlanningTwoToneIcon');
export const PrivateTwoToneIcon = defineIcon(LockTwoTone, 'PrivateTwoToneIcon');
export const ProviderTwoToneIcon = defineIcon(BusinessTwoTone, 'ProviderTwoToneIcon');
export const SettingsTwoToneIcon = defineIcon(SettingsTwoTone, 'SettingsTwoToneIcon');
export const TopicTwoToneIcon = defineIcon(FolderTwoTone, 'TopicTwoToneIcon');

export type { Props as IconProps };
